import {AppActions, RootState} from 'app/rootReducer';
import {userActions} from 'features/User';
import {Epic} from 'redux-observable';
import {concat, debounceTime, from, of} from 'rxjs';
import {catchError, filter, mergeMap, switchMap} from 'rxjs/operators';
import {MessagingService} from 'services/api';
import {CometChatService} from 'services/api/CometChat';

import {messagingActions} from './messagingSlice';

/**
 * LogOut CometChat Session Epic
 *
 * @param action$ - The stream of incoming actions.
 * @returns An observable stream of actions.
 */
export const cometChatLogOutEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(messagingActions.cometChatLogOut.match),
    switchMap(() =>
      from(CometChatService.logout()).pipe(
        mergeMap(() => [messagingActions.cometChatLogOutSuccess()]),
        catchError((message: string) =>
          concat(
            of(userActions.setAsyncError({filter: 'messaging', message})),
            of(messagingActions.cometChatLogOutFailure()),
          ),
        ),
      ),
    ),
  );
/**
 * LogOut CometChat Session Epic
 *
 * @param action$ - The stream of incoming actions.
 * @returns An observable stream of actions.
 */
export const searchConnectionEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(messagingActions.searchConnection.match),
    debounceTime(300),
    switchMap(({payload}) =>
      from(MessagingService.getConnections(payload)).pipe(
        mergeMap(data => [messagingActions.searchConnectionSuccess(data)]),
        catchError(() =>
          concat(of(messagingActions.searchConnectionFailure())),
        ),
      ),
    ),
  );

/**
 * messagingEpics
 */
export const messagingEpics = [searchConnectionEpic, cometChatLogOutEpic];
